export default "__VITE_ASSET__En$73q$L__"